export default {
  years: {
    id: 'duration.years',
    defaultMessage: `{years, plural,
      one {# year}
      other {# years}
    }`,
  },
  months: {
    id: 'duration.months',
    defaultMessage: `{months, plural,
      one {# month}
      other {# months}
    }`,
  },
  yearsShort: {
    id: 'duration.yearsShort',
    defaultMessage: `{years, plural,
      one {# yr}
      other {# yrs}
    }`,
  },
  monthsShort: {
    id: 'duration.monthsShort',
    defaultMessage: `{months, plural,
      one {# mon}
      other {# mos}
    }`,
  },
  lessThanYearShort: {
    id: 'duration.lessThanYearShort',
    defaultMessage: '{lt} 1 yr',
  },
  lessThanMonthShort: {
    id: 'duration.lessThanMonthShort',
    defaultMessage: '{lt} 1 mon',
  },
  lessThanYear: {
    id: 'duration.lessThanYear',
    defaultMessage: '{lt} 1 year',
  },
  lessThanMonth: {
    id: 'duration.lessThanMonth',
    defaultMessage: '{lt} 1 month',
  },
};
